module.exports = __webpack_public_path__ + "static/media/logs.6acba269.txt";